import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { fetchMiscs } from "../../store/slices/miscsSlice";
import Hero from "./components/Hero";
// import RecentVentures from "./components/RecentVentures";
// import Mission from "./components/Mission";
import Footer from "../../components/base-components/Footer";
import ProjectsGallery from "./components/ProjectsGallery";
// import MobileMission from "./components/MobileMission";
import Loader from "../../components/base-components/Loader";
import ErrorMessage from "../../components/base-components/Error";
// import RecentVenturesLogos from "./components/RecentVenturesLogos";
import { Helmet } from "react-helmet-async";

const Home: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { miscs, status, error } = useSelector(
    (state: RootState) => state.miscs
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchMiscs());
    }
  }, [dispatch, status]);

  if (status === "loading") {
    return <Loader />;
  }

  if (status === "failed") {
    return <ErrorMessage message={error} />;
  }

  const getMiscValue = (key: string) => {
    return (
      miscs.find((misc) => misc.attributes.title === key)?.attributes.value ||
      ""
    );
  };

  return (
    <>
      <Helmet>
        <title>{getMiscValue("homepage_seo_title")}</title>

        <meta
          name="description"
          content={getMiscValue("homepage_seo_description")}
        />

        <link rel="canonical" href={window.location.href} />

        <meta
          property="og:image"
          content="https://www.dancap-group.co.uk/images/dancap-logo-dark.jpg"
        />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta
          property="og:title"
          content={getMiscValue("homepage_seo_title")}
        />
        <meta
          property="og:description"
          content={getMiscValue("homepage_seo_description")}
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://www.dancap-group.co.uk/images/dancap-logo-dark.jpg"
        />
      </Helmet>
      <div className="max-w-container">
        {/* Hero Section */}
        <Hero bannerText={getMiscValue("homepage_banner")} />

        {/* Recent Ventures Logos */}
        {/* <RecentVenturesLogos
        venturesLogosDescription={getMiscValue("homepage_ventures_description")}
      /> */}

        {/* Recent Ventures
      <RecentVentures
        venturesDescription={getMiscValue("homepage_ventures_description")}
      /> */}

        {/* Projects Gallery */}
        <ProjectsGallery
          projectsDescription={getMiscValue("homepage_projects_description")}
        />

        {/* Mission & Vision
      <Mission
        missionText={getMiscValue("homepage_mission")}
        visionText={getMiscValue("homepage_vision")}
      />
      <MobileMission
        missionText={getMiscValue("homepage_mission")}
        visionText={getMiscValue("homepage_vision")}
      /> */}

        <Footer />
      </div>
    </>
  );
};

export default Home;
